import { render, staticRenderFns } from "./comingSoon.vue?vue&type=template&id=42dc36d0&scoped=true"
import script from "./comingSoon.vue?vue&type=script&lang=js"
export * from "./comingSoon.vue?vue&type=script&lang=js"
import style0 from "./comingSoon.vue?vue&type=style&index=0&id=42dc36d0&prod&lang=scss"
import style1 from "./comingSoon.vue?vue&type=style&index=1&id=42dc36d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dc36d0",
  null
  
)

export default component.exports